<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Añadir" : "Actualizar" }} Usuario</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <vs-input label="Nombres" v-model="dataName" class="mt-5 w-full" name="item-name" />

        <vs-input label="Apellidos" v-model="dataLastName" class="mt-5 w-full" name="item-last-name" />

        <vs-input label="Correo" v-model="dataEmail" class="mt-5 w-full" name="item-email" />

        <div class="mt-5">
          <small>Selecciona un rol:</small>
          <v-select :options="roleOptions" v-model="roleUser" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData">Aceptar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  data () {
    return {
      roleOptions: [
        { label: "Operador", value: "operator" },
        { label: "Invitado", value: "invited" },
      ],
      roleUser: null,
      dataId: null,
      dataName: "",
      dataLastName: "",
      dataEmail: "",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, email, name, last_name } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataEmail = email
        this.dataName = name
        this.dataLastName = last_name
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    selectedCompany() {
      return this.$store.state.account.user.me.selected_company.id;
    }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ""
      this.dataLastName = ""
      this.dataEmail = ""
    },
    submitData () {
      if (this.dataId) {
        //this.$store.dispatch('dataList/updateItem', {user: {email: this.dataEmail, name: this.dataName, last_name: this.dataLastName}}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('users/inviteUser', {user: {email: this.dataEmail, name: this.dataName, last_name: this.dataLastName, role: this.roleUser.value}, company_id: this.selectedCompany})
          .then(() => {
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch(err => { console.error(err) })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
